// extracted by mini-css-extract-plugin
export default {"wrapper__title":"CreateNewPassword_wrapper__title__PhqUS","wrapper__subtitle":"CreateNewPassword_wrapper__subtitle__m777T"};